import React, { useState } from 'react';
import I18n from 'i18n-js';

import { RCTextWithIcon, RCPopover, RCText, RCButton } from '@reverbdotcom/cadence/components';
import { MapPinLineIcon, TagIcon, LockIcon } from '@reverbdotcom/cadence/icons/react';
import SanitizedRender from './sanitized_render';
import CoreLink from './core_link';
import { useHelpCenterArticleUrl } from '../url_helpers';


const ACCESS_POINTS_HELP_CENTER_ARTICLE_ID = '53752523634971';

function PickupNearBy({ showMapPinIcon }: { showMapPinIcon: boolean }) {
  if (showMapPinIcon) {
    return (
      <RCTextWithIcon
        icon={<MapPinLineIcon />}
        placement="left"
      >
        <RCText.Utility size="350">
          {I18n.t('commons.accessPointCallout.pickUpNearby')}
        </RCText.Utility>
      </RCTextWithIcon>
    );
  }

  return (
    <RCText.Utility size="350">
      {I18n.t('commons.accessPointCallout.pickUpNearby')}
    </RCText.Utility>
  );
}

export default function AccessPointPickupCallout({ showMapPinIcon = false }: { showMapPinIcon?: boolean }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <span className="fg-color-text-primary">
      <RCPopover
        isOpen={isOpen}
        onDismiss={() => setIsOpen(false)}
        anchor={
          <RCButton
            variant="link"
            size="small"
            onClick={() => setIsOpen(!isOpen)}
          >
            <PickupNearBy showMapPinIcon={showMapPinIcon} />
          </RCButton>
        }
      >
        <div className="d-flex gap-2 fx-dir-col">
          <div>
            <RCTextWithIcon
              icon={<MapPinLineIcon />}
              placement="left"
            >
              {I18n.t('commons.accessPointCallout.shipToUpsStores')}
              <CoreLink
                to={useHelpCenterArticleUrl(ACCESS_POINTS_HELP_CENTER_ARTICLE_ID)}
              >
                {I18n.t('commons.accessPointCallout.learnMore')}
              </CoreLink>
            </RCTextWithIcon>
          </div>
          <div>
            <RCTextWithIcon
              icon={<TagIcon />}
              placement="left"
            >
              <SanitizedRender
                html={I18n.t('commons.accessPointCallout.saveOnShippingCosts',
                  {
                    tagOpen: '<strong>',
                    tagClose: '</strong>',
                  },
                )}
              />
            </RCTextWithIcon>
          </div>
          <div>
            <RCTextWithIcon
              icon={<LockIcon />}
              placement="left"
            >
              {I18n.t('commons.accessPointCallout.keepGearSafe')}
            </RCTextWithIcon>
          </div>
        </div>
      </RCPopover>
      <span className="text-utility-350">
        {I18n.t('commons.accessPointCallout.saveOnShipping')}
      </span>
    </span>
  );
}
